module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/30_70c20c7b8a07c8f9ac2b2230c7e09530.jpg";